import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'module-maintenance',
  standalone: true,
  imports: [],
  templateUrl: './module-maintenance.component.html',
  styleUrl: './module-maintenance.component.css'
})
export class ModuleMaintenanceComponent implements OnInit {

   moduleName = '';

  constructor(private route: ActivatedRoute) {}

  ngOnInit(): void {

    // this.route.queryParams.subscribe(params => {
    //   this.moduleName = params['module'] || 'This Module';
    // });

  }


}
